// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Device Config Overlay */
.device-config-overlay {
  position: fixed;
  inset: 0;
  background: rgba(0, 0, 0, 0.7);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 4000;
  padding: 16px;
  backdrop-filter: blur(6px);
  animation: fadeIn 0.2s ease-out;
}

@keyframes fadeIn {
  from {
    opacity: 0;
  }
  to {
    opacity: 1;
  }
}

/* Container */
.device-config-container {
  background: #0a0a0a;
  border-radius: 12px;
  box-shadow: 0 20px 60px rgba(0, 0, 0, 0.8);
  max-width: 600px;
  width: 100%;
  max-height: 90vh;
  display: flex;
  flex-direction: column;
  border: 1px solid #1f2937;
  overflow: hidden;
  animation: slideUp 0.3s ease-out;
}

@keyframes slideUp {
  from {
    opacity: 0;
    transform: translateY(20px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
}

/* Header */
.device-config-header {
  background: #000000;
  border-bottom: 1px solid #1f2937;
  padding: 20px 24px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  flex-shrink: 0;
}

.device-config-header-content {
  display: flex;
  align-items: center;
  gap: 16px;
  flex: 1 1;
}

.device-config-icon {
  width: 48px;
  height: 48px;
  border-radius: 10px;
  background: linear-gradient(135deg, #60a5fa, #3b82f6);
  display: flex;
  align-items: center;
  justify-content: center;
  color: white;
  flex-shrink: 0;
}

.device-config-title {
  margin: 0;
  font-size: 18px;
  font-weight: 600;
  color: #ffffff;
}

.device-config-subtitle {
  margin: 4px 0 0 0;
  font-size: 13px;
  color: #9ca3af;
}

.device-config-serial {
  font-family: 'Courier New', monospace;
  color: #60a5fa;
  font-weight: 500;
}

.device-config-close-btn {
  background: transparent;
  border: none;
  color: #9ca3af;
  cursor: pointer;
  padding: 4px;
  display: flex;
  align-items: center;
  justify-content: center;
  transition: color 0.2s;
  flex-shrink: 0;
}

.device-config-close-btn:hover {
  color: #ffffff;
}

/* Content */
.device-config-body {
  flex: 1 1;
  overflow-y: auto;
  padding: 24px;
  background: #0a0a0a;
}

.config-required-warning {
  display: flex;
  align-items: center;
  gap: 10px;
  padding: 12px 16px;
  background: rgba(251, 146, 60, 0.1);
  border: 1px solid rgba(251, 146, 60, 0.3);
  border-radius: 8px;
  color: #fb923c;
  font-size: 13px;
  font-weight: 500;
  margin-bottom: 24px;
}

.config-field-description {
  font-size: 14px;
  color: #9ca3af;
  line-height: 1.6;
  padding: 12px 16px;
  background: rgba(96, 165, 250, 0.05);
  border-left: 3px solid #60a5fa;
  border-radius: 4px;
}

.device-config-form {
  display: flex;
  flex-direction: column;
  gap: 20px;
}

.config-form-field {
  display: flex;
  flex-direction: column;
  gap: 8px;
}

.config-form-row {
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  gap: 16px;
}

.config-form-label {
  font-size: 14px;
  font-weight: 500;
  color: #e5e7eb;
}

.config-input {
  padding: 10px 12px;
  background: #000000;
  border: 1px solid #374151;
  border-radius: 8px;
  color: #ffffff;
  font-size: 14px;
  outline: none;
  transition: all 0.2s;
}

.config-input:focus {
  border-color: #60a5fa;
  box-shadow: 0 0 0 3px rgba(96, 165, 250, 0.1);
}

.config-input::placeholder {
  color: #6b7280;
}

.config-input.input-error {
  border-color: #ef4444;
  background: rgba(239, 68, 68, 0.05);
}

.config-input.input-error:focus {
  border-color: #ef4444;
  box-shadow: 0 0 0 3px rgba(239, 68, 68, 0.1);
}

.config-input--readonly {
  background: #000000;
  border-color: #374151;
  color: #9ca3af;
  cursor: default;
}

.config-input-with-button {
  display: flex;
  gap: 8px;
  align-items: center;
}

.config-input-with-button .config-input {
  flex: 1 1;
}

.config-location-btn {
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 10px;
  background: #A61B34;
  border: 1px solid #A61B34;
  border-radius: 8px;
  color: #ffffff;
  cursor: pointer;
  transition: all 0.2s;
  flex-shrink: 0;
}

.config-location-btn:hover {
  background: #8B1528;
  border-color: #8B1528;
}

.config-location-btn:active {
  transform: scale(0.95);
}

.config-textarea {
  padding: 10px 12px;
  background: #000000;
  border: 1px solid #374151;
  border-radius: 8px;
  color: #ffffff;
  font-size: 14px;
  outline: none;
  transition: all 0.2s;
  font-family: inherit;
  resize: vertical;
  min-height: 80px;
}

.config-textarea:focus {
  border-color: #60a5fa;
  box-shadow: 0 0 0 3px rgba(96, 165, 250, 0.1);
}

.config-textarea::placeholder {
  color: #6b7280;
}

.config-field-error {
  display: flex;
  align-items: center;
  gap: 4px;
  color: #f87171;
  font-size: 12px;
  animation: fadeIn 0.2s ease-out;
}

.config-field-error::before {
  content: '⚠';
  font-size: 14px;
}

/* Checkboxes */
.config-form-checkbox {
  padding: 12px 0;
}

.config-form-checkboxes {
  display: flex;
  gap: 24px;
  padding: 12px 0;
  flex-wrap: wrap;
}

.config-checkbox-label {
  display: flex;
  align-items: center;
  gap: 8px;
  cursor: pointer;
  font-size: 14px;
  color: #e5e7eb;
  -webkit-user-select: none;
          user-select: none;
}

.config-checkbox-label input[type="checkbox"] {
  width: 18px;
  height: 18px;
  cursor: pointer;
  accent-color: #60a5fa;
}

.config-checkbox-label span {
  transition: color 0.2s;
}

.config-checkbox-label:hover span {
  color: #ffffff;
}

/* Footer */
.device-config-footer {
  background: #000000;
  border-top: 1px solid #1f2937;
  padding: 20px 24px;
  display: flex;
  align-items: center;
  justify-content: flex-end;
  gap: 12px;
  flex-shrink: 0;
}

.config-btn-primary {
  display: flex;
  align-items: center;
  gap: 8px;
  padding: 10px 24px;
  background: linear-gradient(135deg, #60a5fa, #3b82f6);
  color: #ffffff;
  border: none;
  border-radius: 8px;
  font-size: 14px;
  font-weight: 600;
  cursor: pointer;
  transition: all 0.2s;
}

.config-btn-primary:hover {
  background: linear-gradient(135deg, #3b82f6, #2563eb);
  transform: translateY(-1px);
  box-shadow: 0 4px 12px rgba(59, 130, 246, 0.4);
}

.config-btn-primary:active {
  transform: translateY(0);
}

.config-btn-secondary {
  display: flex;
  align-items: center;
  gap: 8px;
  padding: 10px 24px;
  background: transparent;
  color: #9ca3af;
  border: 1px solid #374151;
  border-radius: 8px;
  font-size: 14px;
  font-weight: 600;
  cursor: pointer;
  transition: all 0.2s;
}

.config-btn-secondary:hover {
  background: #1a1a1a;
  color: #ffffff;
  border-color: #4b5563;
}

.config-btn-cancel {
  display: flex;
  align-items: center;
  gap: 8px;
  padding: 10px 24px;
  background: transparent;
  color: #ef4444;
  border: 1px solid #ef4444;
  border-radius: 8px;
  font-size: 14px;
  font-weight: 600;
  cursor: pointer;
  transition: all 0.2s;
}

.config-btn-cancel:hover {
  background: rgba(239, 68, 68, 0.1);
  color: #f87171;
  border-color: #f87171;
}

/* Scrollbar */
.device-config-content::-webkit-scrollbar {
  width: 10px;
}

.device-config-content::-webkit-scrollbar-track {
  background: #000000;
}

.device-config-content::-webkit-scrollbar-thumb {
  background: #374151;
  border-radius: 5px;
}

.device-config-content::-webkit-scrollbar-thumb:hover {
  background: #4b5563;
}

/* Responsive */
@media (max-width: 768px) {
  .config-form-row {
    grid-template-columns: 1fr;
  }

  .device-config-container {
    max-width: 100%;
    max-height: 95vh;
  }

  .config-form-checkboxes {
    flex-direction: column;
    gap: 12px;
  }
}
`, "",{"version":3,"sources":["webpack://./src/components/DeviceConfigModal.css"],"names":[],"mappings":"AAAA,0BAA0B;AAC1B;EACE,eAAe;EACf,QAAQ;EACR,8BAA8B;EAC9B,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,aAAa;EACb,aAAa;EACb,0BAA0B;EAC1B,+BAA+B;AACjC;;AAEA;EACE;IACE,UAAU;EACZ;EACA;IACE,UAAU;EACZ;AACF;;AAEA,cAAc;AACd;EACE,mBAAmB;EACnB,mBAAmB;EACnB,0CAA0C;EAC1C,gBAAgB;EAChB,WAAW;EACX,gBAAgB;EAChB,aAAa;EACb,sBAAsB;EACtB,yBAAyB;EACzB,gBAAgB;EAChB,gCAAgC;AAClC;;AAEA;EACE;IACE,UAAU;IACV,2BAA2B;EAC7B;EACA;IACE,UAAU;IACV,wBAAwB;EAC1B;AACF;;AAEA,WAAW;AACX;EACE,mBAAmB;EACnB,gCAAgC;EAChC,kBAAkB;EAClB,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,SAAO;AACT;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,mBAAmB;EACnB,qDAAqD;EACrD,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,YAAY;EACZ,cAAc;AAChB;;AAEA;EACE,SAAS;EACT,eAAe;EACf,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,iBAAiB;EACjB,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,qCAAqC;EACrC,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,uBAAuB;EACvB,YAAY;EACZ,cAAc;EACd,eAAe;EACf,YAAY;EACZ,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,sBAAsB;EACtB,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA,YAAY;AACZ;EACE,SAAO;EACP,gBAAgB;EAChB,aAAa;EACb,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,kBAAkB;EAClB,mCAAmC;EACnC,yCAAyC;EACzC,kBAAkB;EAClB,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,cAAc;EACd,gBAAgB;EAChB,kBAAkB;EAClB,oCAAoC;EACpC,8BAA8B;EAC9B,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;AACX;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;AACV;;AAEA;EACE,aAAa;EACb,qCAAqC;EACrC,SAAS;AACX;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,kBAAkB;EAClB,mBAAmB;EACnB,yBAAyB;EACzB,kBAAkB;EAClB,cAAc;EACd,eAAe;EACf,aAAa;EACb,oBAAoB;AACtB;;AAEA;EACE,qBAAqB;EACrB,6CAA6C;AAC/C;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,qBAAqB;EACrB,mCAAmC;AACrC;;AAEA;EACE,qBAAqB;EACrB,4CAA4C;AAC9C;;AAEA;EACE,mBAAmB;EACnB,qBAAqB;EACrB,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,QAAQ;EACR,mBAAmB;AACrB;;AAEA;EACE,SAAO;AACT;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,aAAa;EACb,mBAAmB;EACnB,yBAAyB;EACzB,kBAAkB;EAClB,cAAc;EACd,eAAe;EACf,oBAAoB;EACpB,cAAc;AAChB;;AAEA;EACE,mBAAmB;EACnB,qBAAqB;AACvB;;AAEA;EACE,sBAAsB;AACxB;;AAEA;EACE,kBAAkB;EAClB,mBAAmB;EACnB,yBAAyB;EACzB,kBAAkB;EAClB,cAAc;EACd,eAAe;EACf,aAAa;EACb,oBAAoB;EACpB,oBAAoB;EACpB,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA;EACE,qBAAqB;EACrB,6CAA6C;AAC/C;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,cAAc;EACd,eAAe;EACf,+BAA+B;AACjC;;AAEA;EACE,YAAY;EACZ,eAAe;AACjB;;AAEA,eAAe;AACf;EACE,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,SAAS;EACT,eAAe;EACf,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,eAAe;EACf,eAAe;EACf,cAAc;EACd,yBAAiB;UAAjB,iBAAiB;AACnB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,eAAe;EACf,qBAAqB;AACvB;;AAEA;EACE,sBAAsB;AACxB;;AAEA;EACE,cAAc;AAChB;;AAEA,WAAW;AACX;EACE,mBAAmB;EACnB,6BAA6B;EAC7B,kBAAkB;EAClB,aAAa;EACb,mBAAmB;EACnB,yBAAyB;EACzB,SAAS;EACT,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,kBAAkB;EAClB,qDAAqD;EACrD,cAAc;EACd,YAAY;EACZ,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,eAAe;EACf,oBAAoB;AACtB;;AAEA;EACE,qDAAqD;EACrD,2BAA2B;EAC3B,8CAA8C;AAChD;;AAEA;EACE,wBAAwB;AAC1B;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,kBAAkB;EAClB,uBAAuB;EACvB,cAAc;EACd,yBAAyB;EACzB,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,eAAe;EACf,oBAAoB;AACtB;;AAEA;EACE,mBAAmB;EACnB,cAAc;EACd,qBAAqB;AACvB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,kBAAkB;EAClB,uBAAuB;EACvB,cAAc;EACd,yBAAyB;EACzB,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,eAAe;EACf,oBAAoB;AACtB;;AAEA;EACE,kCAAkC;EAClC,cAAc;EACd,qBAAqB;AACvB;;AAEA,cAAc;AACd;EACE,WAAW;AACb;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;EACnB,kBAAkB;AACpB;;AAEA;EACE,mBAAmB;AACrB;;AAEA,eAAe;AACf;EACE;IACE,0BAA0B;EAC5B;;EAEA;IACE,eAAe;IACf,gBAAgB;EAClB;;EAEA;IACE,sBAAsB;IACtB,SAAS;EACX;AACF","sourcesContent":["/* Device Config Overlay */\n.device-config-overlay {\n  position: fixed;\n  inset: 0;\n  background: rgba(0, 0, 0, 0.7);\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  z-index: 4000;\n  padding: 16px;\n  backdrop-filter: blur(6px);\n  animation: fadeIn 0.2s ease-out;\n}\n\n@keyframes fadeIn {\n  from {\n    opacity: 0;\n  }\n  to {\n    opacity: 1;\n  }\n}\n\n/* Container */\n.device-config-container {\n  background: #0a0a0a;\n  border-radius: 12px;\n  box-shadow: 0 20px 60px rgba(0, 0, 0, 0.8);\n  max-width: 600px;\n  width: 100%;\n  max-height: 90vh;\n  display: flex;\n  flex-direction: column;\n  border: 1px solid #1f2937;\n  overflow: hidden;\n  animation: slideUp 0.3s ease-out;\n}\n\n@keyframes slideUp {\n  from {\n    opacity: 0;\n    transform: translateY(20px);\n  }\n  to {\n    opacity: 1;\n    transform: translateY(0);\n  }\n}\n\n/* Header */\n.device-config-header {\n  background: #000000;\n  border-bottom: 1px solid #1f2937;\n  padding: 20px 24px;\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  flex-shrink: 0;\n}\n\n.device-config-header-content {\n  display: flex;\n  align-items: center;\n  gap: 16px;\n  flex: 1;\n}\n\n.device-config-icon {\n  width: 48px;\n  height: 48px;\n  border-radius: 10px;\n  background: linear-gradient(135deg, #60a5fa, #3b82f6);\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  color: white;\n  flex-shrink: 0;\n}\n\n.device-config-title {\n  margin: 0;\n  font-size: 18px;\n  font-weight: 600;\n  color: #ffffff;\n}\n\n.device-config-subtitle {\n  margin: 4px 0 0 0;\n  font-size: 13px;\n  color: #9ca3af;\n}\n\n.device-config-serial {\n  font-family: 'Courier New', monospace;\n  color: #60a5fa;\n  font-weight: 500;\n}\n\n.device-config-close-btn {\n  background: transparent;\n  border: none;\n  color: #9ca3af;\n  cursor: pointer;\n  padding: 4px;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  transition: color 0.2s;\n  flex-shrink: 0;\n}\n\n.device-config-close-btn:hover {\n  color: #ffffff;\n}\n\n/* Content */\n.device-config-body {\n  flex: 1;\n  overflow-y: auto;\n  padding: 24px;\n  background: #0a0a0a;\n}\n\n.config-required-warning {\n  display: flex;\n  align-items: center;\n  gap: 10px;\n  padding: 12px 16px;\n  background: rgba(251, 146, 60, 0.1);\n  border: 1px solid rgba(251, 146, 60, 0.3);\n  border-radius: 8px;\n  color: #fb923c;\n  font-size: 13px;\n  font-weight: 500;\n  margin-bottom: 24px;\n}\n\n.config-field-description {\n  font-size: 14px;\n  color: #9ca3af;\n  line-height: 1.6;\n  padding: 12px 16px;\n  background: rgba(96, 165, 250, 0.05);\n  border-left: 3px solid #60a5fa;\n  border-radius: 4px;\n}\n\n.device-config-form {\n  display: flex;\n  flex-direction: column;\n  gap: 20px;\n}\n\n.config-form-field {\n  display: flex;\n  flex-direction: column;\n  gap: 8px;\n}\n\n.config-form-row {\n  display: grid;\n  grid-template-columns: repeat(2, 1fr);\n  gap: 16px;\n}\n\n.config-form-label {\n  font-size: 14px;\n  font-weight: 500;\n  color: #e5e7eb;\n}\n\n.config-input {\n  padding: 10px 12px;\n  background: #000000;\n  border: 1px solid #374151;\n  border-radius: 8px;\n  color: #ffffff;\n  font-size: 14px;\n  outline: none;\n  transition: all 0.2s;\n}\n\n.config-input:focus {\n  border-color: #60a5fa;\n  box-shadow: 0 0 0 3px rgba(96, 165, 250, 0.1);\n}\n\n.config-input::placeholder {\n  color: #6b7280;\n}\n\n.config-input.input-error {\n  border-color: #ef4444;\n  background: rgba(239, 68, 68, 0.05);\n}\n\n.config-input.input-error:focus {\n  border-color: #ef4444;\n  box-shadow: 0 0 0 3px rgba(239, 68, 68, 0.1);\n}\n\n.config-input--readonly {\n  background: #000000;\n  border-color: #374151;\n  color: #9ca3af;\n  cursor: default;\n}\n\n.config-input-with-button {\n  display: flex;\n  gap: 8px;\n  align-items: center;\n}\n\n.config-input-with-button .config-input {\n  flex: 1;\n}\n\n.config-location-btn {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  padding: 10px;\n  background: #A61B34;\n  border: 1px solid #A61B34;\n  border-radius: 8px;\n  color: #ffffff;\n  cursor: pointer;\n  transition: all 0.2s;\n  flex-shrink: 0;\n}\n\n.config-location-btn:hover {\n  background: #8B1528;\n  border-color: #8B1528;\n}\n\n.config-location-btn:active {\n  transform: scale(0.95);\n}\n\n.config-textarea {\n  padding: 10px 12px;\n  background: #000000;\n  border: 1px solid #374151;\n  border-radius: 8px;\n  color: #ffffff;\n  font-size: 14px;\n  outline: none;\n  transition: all 0.2s;\n  font-family: inherit;\n  resize: vertical;\n  min-height: 80px;\n}\n\n.config-textarea:focus {\n  border-color: #60a5fa;\n  box-shadow: 0 0 0 3px rgba(96, 165, 250, 0.1);\n}\n\n.config-textarea::placeholder {\n  color: #6b7280;\n}\n\n.config-field-error {\n  display: flex;\n  align-items: center;\n  gap: 4px;\n  color: #f87171;\n  font-size: 12px;\n  animation: fadeIn 0.2s ease-out;\n}\n\n.config-field-error::before {\n  content: '⚠';\n  font-size: 14px;\n}\n\n/* Checkboxes */\n.config-form-checkbox {\n  padding: 12px 0;\n}\n\n.config-form-checkboxes {\n  display: flex;\n  gap: 24px;\n  padding: 12px 0;\n  flex-wrap: wrap;\n}\n\n.config-checkbox-label {\n  display: flex;\n  align-items: center;\n  gap: 8px;\n  cursor: pointer;\n  font-size: 14px;\n  color: #e5e7eb;\n  user-select: none;\n}\n\n.config-checkbox-label input[type=\"checkbox\"] {\n  width: 18px;\n  height: 18px;\n  cursor: pointer;\n  accent-color: #60a5fa;\n}\n\n.config-checkbox-label span {\n  transition: color 0.2s;\n}\n\n.config-checkbox-label:hover span {\n  color: #ffffff;\n}\n\n/* Footer */\n.device-config-footer {\n  background: #000000;\n  border-top: 1px solid #1f2937;\n  padding: 20px 24px;\n  display: flex;\n  align-items: center;\n  justify-content: flex-end;\n  gap: 12px;\n  flex-shrink: 0;\n}\n\n.config-btn-primary {\n  display: flex;\n  align-items: center;\n  gap: 8px;\n  padding: 10px 24px;\n  background: linear-gradient(135deg, #60a5fa, #3b82f6);\n  color: #ffffff;\n  border: none;\n  border-radius: 8px;\n  font-size: 14px;\n  font-weight: 600;\n  cursor: pointer;\n  transition: all 0.2s;\n}\n\n.config-btn-primary:hover {\n  background: linear-gradient(135deg, #3b82f6, #2563eb);\n  transform: translateY(-1px);\n  box-shadow: 0 4px 12px rgba(59, 130, 246, 0.4);\n}\n\n.config-btn-primary:active {\n  transform: translateY(0);\n}\n\n.config-btn-secondary {\n  display: flex;\n  align-items: center;\n  gap: 8px;\n  padding: 10px 24px;\n  background: transparent;\n  color: #9ca3af;\n  border: 1px solid #374151;\n  border-radius: 8px;\n  font-size: 14px;\n  font-weight: 600;\n  cursor: pointer;\n  transition: all 0.2s;\n}\n\n.config-btn-secondary:hover {\n  background: #1a1a1a;\n  color: #ffffff;\n  border-color: #4b5563;\n}\n\n.config-btn-cancel {\n  display: flex;\n  align-items: center;\n  gap: 8px;\n  padding: 10px 24px;\n  background: transparent;\n  color: #ef4444;\n  border: 1px solid #ef4444;\n  border-radius: 8px;\n  font-size: 14px;\n  font-weight: 600;\n  cursor: pointer;\n  transition: all 0.2s;\n}\n\n.config-btn-cancel:hover {\n  background: rgba(239, 68, 68, 0.1);\n  color: #f87171;\n  border-color: #f87171;\n}\n\n/* Scrollbar */\n.device-config-content::-webkit-scrollbar {\n  width: 10px;\n}\n\n.device-config-content::-webkit-scrollbar-track {\n  background: #000000;\n}\n\n.device-config-content::-webkit-scrollbar-thumb {\n  background: #374151;\n  border-radius: 5px;\n}\n\n.device-config-content::-webkit-scrollbar-thumb:hover {\n  background: #4b5563;\n}\n\n/* Responsive */\n@media (max-width: 768px) {\n  .config-form-row {\n    grid-template-columns: 1fr;\n  }\n\n  .device-config-container {\n    max-width: 100%;\n    max-height: 95vh;\n  }\n\n  .config-form-checkboxes {\n    flex-direction: column;\n    gap: 12px;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
